// Dok 01 – Rutin: Systematiskt arbetsmiljöarbete under planering och projektering (Bas-P)

export interface SamSectionDef {
  key: string;
  title: string;
  hint: string;
  /** Förifylld standardtext som användaren kan justera */
  template: string;
}

export const SAM_ROUTINE_SECTIONS: SamSectionDef[] = [
  {
    key: "bakgrund",
    title: "1. Bakgrund",
    hint: "Varför rutinen finns och vilket krav den svarar mot.",
    template:
      "Byggherren ansvarar för att arbetsmiljöfrågor beaktas under planering och projektering av byggnads- och anläggningsarbete. Byggarbetsmiljösamordnare för planering och projektering (Bas-P) utses skriftligt och ska samordna arbetsmiljöarbetet så att risker byggs bort eller hanteras redan innan produktionen startar. Denna rutin beskriver hur arbetet bedrivs systematiskt, spårbart och likartat i projektets alla skeden.",
  },
  {
    key: "syfte",
    title: "2. Syfte",
    hint: "Vad rutinen ska åstadkomma.",
    template:
      "Syftet är att säkerställa att arbetsmiljörisker identifieras, bedöms och åtgärdas i rätt skede, att beslut och avvägningar dokumenteras, att underlaget förs vidare till arbetsmiljöplanen och till Bas-U samt att kvarstående risker överlämnas till bruksskedet. Rutinen ska också göra det möjligt att i efterhand visa hur arbetsmiljöarbetet har bedrivits.",
  },
  {
    key: "omfattning",
    title: "3. Omfattning och avgränsning",
    hint: "Vilka skeden, aktörer och arbeten som omfattas.",
    template:
      "Rutinen omfattar hela planerings- och projekteringsskedet, från uppdragsstart till överlämning till Bas-U, samt de projekteringsinsatser som pågår parallellt med produktionen. Den gäller för Bas-P, projektörer och övriga som lämnar underlag som påverkar arbetsmiljön i bygg- och bruksskedet.",
  },
  {
    key: "ansvar",
    title: "4. Roller och ansvar",
    hint: "Byggherre, Bas-P, projektörer, Bas-U.",
    template:
      "Byggherre: utser Bas-P och Bas-U skriftligt, tillhandahåller förutsättningar och underlag samt lämnar förhandsanmälan när kraven är uppfyllda.\nBas-P: samordnar arbetsmiljöarbetet under projekteringen, upprättar arbetsmiljöplanen, driver risksammanställningen och överlämnar underlaget till Bas-U.\nProjektörer: identifierar och redovisar arbetsmiljörisker i sina egna handlingar och deltar i riskgenomgångar.\nBas-U: tar emot underlaget, anpassar arbetsmiljöplanen till utförandet och återkopplar avvikelser till Bas-P.",
  },
  {
    key: "arbetsgang",
    title: "5. Arbetsgång – undersöka, riskbedöma, åtgärda, kontrollera",
    hint: "SAM-hjulet tillämpat på projekteringen.",
    template:
      "Undersöka: förutsättningar samlas in genom projektförutsättningar/SKR-profil (Dok 03) och arbetsområdesutredning (Dok 10).\nRiskbedöma: risker värderas i risksammanställningen (Dok 11) med sannolikhet och konsekvens, och de särskilda riskerna bedöms (Dok 13).\nÅtgärda: åtgärder beslutas i första hand genom ändrad projektering, därefter genom tekniska och organisatoriska åtgärder, med ansvarig och tidpunkt.\nKontrollera: åtgärdernas effekt följs upp vid granskning (Dok 14) och i utförandet (Dok 21). Nya förutsättningar startar om hjulet.",
  },
  {
    key: "moten",
    title: "6. Möten, samordning och kommunikation",
    hint: "När arbetsmiljöfrågor tas upp och av vem.",
    template:
      "Arbetsmiljö är en stående punkt på projekterings- och samordningsmöten. Riskgenomgångar hålls vid varje skedesväxling och vid större ändringar. Frågor och svar som påverkar arbetsmiljön loggas i Q&A-loggen (Dok 25). Vid parallell projektering och produktion hålls samordningsmöten mellan Bas-P och Bas-U (Dok 23).",
  },
  {
    key: "dokumentation",
    title: "7. Dokumentation och spårbarhet",
    hint: "Hur beslut, versioner och underlag hanteras.",
    template:
      "Samtliga bedömningar, beslut och åtgärder dokumenteras i systemet med datum, ansvarig och version. Risksammanställningen är projektets huvudregister och arbetsmiljöplanen (Dok 12) är det styrande dokumentet på arbetsplatsen. Revideringar sparas med revisionsnot så att tidigare versioner kan följas.",
  },
  {
    key: "uppfoljning",
    title: "8. Uppföljning och förbättring av rutinen",
    hint: "Hur rutinen granskas och hålls aktuell.",
    template:
      "Rutinen följs upp minst en gång per projekt samt vid tillbud, avvikelser eller ändrade förutsättningar. Erfarenheter från utförandet och från tillbudsrapporteringen (Dok 28) återförs till kommande projekt. Ansvarig för uppföljningen är Bas-P i samråd med byggherren.",
  },
];

export type SamRoutineStatus = "utkast" | "granskad" | "faststalld";

export const SAM_ROUTINE_STATUS_LABELS: Record<SamRoutineStatus, string> = {
  utkast: "Utkast",
  granskad: "Granskad",
  faststalld: "Fastställd",
};
